module.exports = __webpack_public_path__ + "img/contentBg.90707ccf.png";